import { getSentry } from './sentry/initSentryBrowser';


// eslint-disable-next-line @typescript-eslint/no-explicit-any
type ExtraArgType = Record<string, any>;

export interface ILogger {
  error(error: Error | string, extra?: ExtraArgType): void;
  warn(error: Error | string, extra?: ExtraArgType): void;
}

export class SentryLogger implements ILogger {
  async error(input: Error | string, extra?: ExtraArgType): Promise<void> {
    const Sentry = await getSentry();
    if (extra) {
      Sentry.setExtras(extra);
    }

    if (typeof input === 'string') {
      const error = new Error(input);
      Sentry.captureException(error);
    } else {
      Sentry.captureException(input);
    }
  }

  async warn(input: Error | string, extra?: ExtraArgType): Promise<void> {
    await this.error(input, { ...(extra || {}), level: 'warning' });
  }
}

export const logger = new SentryLogger();
